export default __webpack_public_path__ + "static/media/arrows-down-41x90.22c13850.svg";